import React, { useRef, useEffect } from 'react';
import AliceCarousel from 'react-alice-carousel';
import ClientTestimony from './Testimony/ClientTestimony';
import ArrowLong from 'components/ui/icons/ArrowLong';
import { CarouselContainer, NextButton, PrevButton } from './styles';
import { homepageClients, homepageMoms } from 'consts';
import PropTypes from 'prop-types';
import MomTestimony from './Testimony/MomTestimony';
import { screenSizeInt } from 'styleGuide';
import { useClientRect } from 'utilities/hooks';
import themed from 'components/hoc/themed';

const TestimonyCarousel = ({ mode }) => {
  const responsiveConfig = {
    0: { items: 1 },
    600: { items: 1 },
    1024: { items: 1 },
  };
  const container = useRef(null);
  const [rect1, clientRef1] = useClientRect();
  const [rect2, clientRef2] = useClientRect();
  const [rect3, clientRef3] = useClientRect();
  const [rect4, clientRef4] = useClientRect();
  const [rect5, clientRef5] = useClientRect();
  const [rect6, momRef1] = useClientRect();
  const [rect7, momRef2] = useClientRect();
  const [rect8, momRef3] = useClientRect();

  const itemRects = {
    client: [rect1, rect2, rect3, rect4, rect5],
    mom: [rect6, rect7, rect8],
  };

  const carouselItems = {
    client: [
      <ClientTestimony key={0} {...homepageClients[0]} ref={clientRef1} />,
      <ClientTestimony key={1} {...homepageClients[1]} ref={clientRef2} />,
      <ClientTestimony key={2} {...homepageClients[2]} ref={clientRef3} />,
      <ClientTestimony key={2} {...homepageClients[3]} ref={clientRef4} />,
      <ClientTestimony key={2} {...homepageClients[4]} ref={clientRef5} />,
    ],
    mom: [
      <MomTestimony key={0} {...homepageMoms[0]} ref={momRef1} />,
      <MomTestimony key={1} {...homepageMoms[1]} ref={momRef2} />,
      <MomTestimony key={2} {...homepageMoms[2]} ref={momRef3} />,
    ],
  };
  let carousel;

  // Sets the initial position as soon as it renders
  useEffect(function () {
    rect1 && carousel && setDotsPosition(rect1);
  });

  const handleOnResize = e => {
    const articlePosition = itemRects[mode][e.item];
    mode === 'client' && setDotsPosition(articlePosition);
  };

  const setDotsPosition = articlePosition => {
    const screenWidth = window.innerWidth;
    const dotsElement = container.current.firstChild.getElementsByClassName(
      'alice-carousel__dots',
    )[0];
    if (screenWidth > screenSizeInt.mobileL) {
      if (screenWidth > articlePosition.width) {
        const calculatedPosition =
          (screenWidth - articlePosition.width) / 2 + 20;
        dotsElement.style = `right: ${calculatedPosition}px;`;
      } else {
        dotsElement.style = `right: 20px;`;
      }
    }
  };

  return (
    <CarouselContainer className="carousel" mode={mode} ref={container}>
      <AliceCarousel
        responsive={responsiveConfig}
        infinite={true}
        mouseDragEnabled
        buttonsDisabled={true}
        items={carouselItems[mode]}
        swipeDisabled={true}
        ref={el => (carousel = el)}
        onResized={handleOnResize}
      />
      <PrevButton
        data-id="testimony-prev-btn"
        data-testid="prev-btn"
        onClick={() => carousel.slidePrev()}
        mode={mode}
      >
        <ArrowLong direction="left" />
      </PrevButton>
      <NextButton
        data-id="testimony-next-btn"
        data-testid="next-btn"
        onClick={() => carousel.slideNext()}
        mode={mode}
      >
        <ArrowLong />
      </NextButton>
    </CarouselContainer>
  );
};

TestimonyCarousel.propTypes = {
  mode: PropTypes.oneOf(['client', 'mom']),
};

export default themed(TestimonyCarousel);
